export const disclaimer: CSSFunction = () => ({
    display: 'flex',
    flexDirection: 'column',
});

export const disclaimerCharges = {
    listStyleType: 'disc',
    paddingLeft: '12px',
};

export const retryLoading = {
    cursor: 'pointer',
    marginLeft: '8px',
};
